(() => {
  if (window.__cvYoutubeGateInstalled) return;
  window.__cvYoutubeGateInstalled = true;

  const apiScripts = new Set();
  let sequence = 0;

  const absolute = (value) => {
    try {
      return new URL(String(value || ''), document.baseURI).href;
    } catch (_) {
      return String(value || '');
    }
  };

  const isEmbed = (value) => {
    const url = absolute(value).toLowerCase();
    return url.includes('youtube.com/embed/') || url.includes('youtube-nocookie.com/embed/');
  };

  const videoId = (value) => {
    const match = absolute(value).match(/\/embed\/([^?&#/]+)/i);
    return match ? match[1] : '';
  };

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[character]);

  const posterMarkup = (source, key, title) => {
    const id = videoId(source);
    const poster = id ? `https://i.ytimg.com/vi/${encodeURIComponent(id)}/hqdefault.jpg` : '';
    const background = poster ? `background-image:url('${poster}')` : '';
    return [
      '<!doctype html><html><head>',
      '<meta name="viewport" content="width=device-width,initial-scale=1">',
      '<style>',
      '*{box-sizing:border-box}html,body{margin:0;width:100%;height:100%;background:#111}',
      `button{width:100%;height:100%;border:0;cursor:pointer;display:grid;place-items:center;background:#111 center/cover no-repeat;${background}}`,
      'span{display:grid;place-items:center;width:68px;height:48px;border-radius:14px;background:#e62117;color:#fff;font:700 25px/1 Arial,sans-serif;box-shadow:0 3px 18px #0008}',
      'button:focus-visible{outline:4px solid #fff;outline-offset:-7px}',
      '</style></head><body>',
      `<button type="button" aria-label="${escapeHtml(title || 'Play YouTube video')}" onclick="parent.postMessage({cvYoutubeLoad:'${key}'},'*')">`,
      '<span aria-hidden="true">&#9654;</span></button>',
      '</body></html>'
    ].join('');
  };

  const deferIframe = (iframe, source) => {
    if (!(iframe instanceof HTMLIFrameElement) || !isEmbed(source)) return;
    if (iframe.dataset.cvYoutubeReady === 'true') return;

    const key = iframe.dataset.cvYoutubeKey || `cvyt-${Date.now()}-${++sequence}`;
    iframe.dataset.cvYoutubeKey = key;
    iframe.dataset.cvYoutubeSrc = absolute(source);
    iframe.setAttribute('title', iframe.getAttribute('title') || 'YouTube video');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.removeAttribute('src');
    iframe.removeAttribute('data-cv-youtube-src');
    iframe.srcdoc = posterMarkup(source, key, iframe.getAttribute('title'));
  };

  const registerApiScript = (script) => {
    if (!(script instanceof HTMLScriptElement)) return;
    const source = script.getAttribute('data-cv-youtube-api-src');
    if (!source) return;
    script.dataset.cvYoutubeApiSrc = source;
    script.type = 'text/plain';
    apiScripts.add(script);
  };

  const releaseApiScripts = () => {
    apiScripts.forEach((oldScript) => {
      const source = oldScript.dataset.cvYoutubeApiSrc;
      if (!source || oldScript.dataset.cvYoutubeReleased === 'true') return;
      oldScript.dataset.cvYoutubeReleased = 'true';
      const replacement = document.createElement('script');
      replacement.src = source;
      replacement.async = true;
      oldScript.replaceWith(replacement);
    });
    apiScripts.clear();
  };

  const activate = (iframe) => {
    if (!(iframe instanceof HTMLIFrameElement)) return;
    const source = iframe.dataset.cvYoutubeSrc;
    if (!source) return;

    releaseApiScripts();
    iframe.dataset.cvYoutubeReady = 'true';
    iframe.removeAttribute('srcdoc');
    delete iframe.dataset.cvYoutubeSrc;
    iframe.src = source;
  };

  const scan = (root = document) => {
    const scope = root instanceof Element || root instanceof Document ? root : document;

    scope.querySelectorAll?.('script[data-cv-youtube-api-src]').forEach(registerApiScript);
    scope.querySelectorAll?.([
      'iframe[data-cv-youtube-src]',
      'iframe[src*="youtube.com/embed/"]',
      'iframe[src*="youtube-nocookie.com/embed/"]'
    ].join(',')).forEach((iframe) => {
      const source = iframe.dataset.cvYoutubeSrc || iframe.getAttribute('data-cv-youtube-src') || iframe.getAttribute('src');
      if (source) deferIframe(iframe, source);
    });
  };

  window.addEventListener('message', (event) => {
    const key = event?.data?.cvYoutubeLoad;
    if (!key) return;
    const safeKey = String(key).replace(/[^a-zA-Z0-9_-]/g, '');
    const iframe = document.querySelector(`iframe[data-cv-youtube-key="${safeKey}"]`);
    activate(iframe);
  });

  const start = () => {
    scan(document);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches('iframe,script')) scan(node.parentElement || document);
          else scan(node);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
